import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
import { useStreams } from "@/composables/stream";
import { Dashboard, DashboardGridSize } from "@/types/Dashboard";
import ArchivedStreamWidget from "@/views/dashboard/componentsV2/ArchivedStreamWidget.vue";
import BaseWidget from "@/views/dashboard/componentsV2/BaseWidget.vue";
import LiveStreamWidget from "@/views/dashboard/componentsV2/LiveStreamWidget.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'StreamWidget',
  props: {
    arg: {},
    width: {},
    height: {},
    dashboardGridSize: {},
    dashboard: {}
  },
  emits: ["delete", "widgetRouteClicked", "trackInteraction"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { streams, isLoading } = useStreams();

const isLive = computed(() => {
  const stream = streams.value.find(({ camera_id }) => camera_id == props.arg);
  return !!stream?.aws_stream_id;
});

return (_ctx: any,_cache: any) => {
  return (_unref(isLoading))
    ? (_openBlock(), _createBlock(BaseWidget, {
        key: 0,
        isLoading: true
      }))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (isLive.value)
          ? (_openBlock(), _createBlock(LiveStreamWidget, _mergeProps({ key: 0 }, _ctx.$props, {
              onDelete: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete'))),
              onWidgetRouteClicked: _cache[1] || (_cache[1] = ($event: any) => (emit('widgetRouteClicked'))),
              onTrackInteraction: _cache[2] || (_cache[2] = ($event: any) => (emit('trackInteraction')))
            }), null, 16))
          : (_openBlock(), _createBlock(ArchivedStreamWidget, _mergeProps({ key: 1 }, _ctx.$props, {
              onDelete: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('delete'))),
              onWidgetRouteClicked: _cache[4] || (_cache[4] = ($event: any) => (emit('widgetRouteClicked')))
            }), null, 16))
      ], 64))
}
}

})